<template>
    <section>
        <div id="print" ref="printContent">
            <div class="jianceCard" ref="sor">
                <el-table :data="deviceinfoData" id="table" :show-header="false" size="mini" border
                    :span-method="arraySpanMethod" :row-style="{ height: '20px' }" :cell-style="tableCellStyle"
                    style="font-size:10px;">
                    <el-table-column prop="prop1" :width="55" align="center"></el-table-column>
                    <el-table-column prop="prop2" :width="123"></el-table-column>
                    <el-table-column prop="prop3" :width="48">
                        <template slot-scope="scop">
                            <img :src="scop.row.prop3"
                                style="width: 110px;height: 110px;margin-left: -12px;margin-top: 5px;"
                                v-if="scop.row.prop3 != '保管人'">
                            <span v-else>{{ scop.row.prop3 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="prop4"></el-table-column>
                </el-table>
            </div>
        </div>
        <div style="margin-top:10px">
            <el-button type="primary" v-print="printObj">打印</el-button>
            <!-- <el-button type="primary" @click="test">图片</el-button> -->

        </div>
    </section>
</template>
<script>
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            printObj: {
                id: 'print',//id
                popTitle: "设备管理卡片",//自定义设置标题
                style: "margin-top:20px"
            },

            map: new Map(),
            qrcodeUrl: "https://deviceinfomanagement.oss-cn-beijing.aliyuncs.com/qrcodeImage/2023-02-25-9-13-2.png",
            deviceinfoData: []
        }
    },
    props: ['deviceinfo'],
    methods: {
        // test() {
        //     // 配置项
        //     const setup = {
        //         useCORS: true, // 使用跨域
        //     };
        //     html2canvas(this.$refs.sor, setup).then((canvas) => {

        //         const link = canvas.toDataURL("image/jpg");
        //         console.log("开始")
        //         console.log(link)
        //         console.log("结束")
        //         this.exportPicture(link, "ce");
        //     });
        // },
        exportPicture(link, name = "未命名文件") {
            const file = document.createElement("a");
            file.style.display = "none";
            file.href = link;
            file.download = decodeURI(name);
            document.body.appendChild(file);
            file.click();
            document.body.removeChild(file);
        },

        // print(){
        //     this.$print(this.$refs.print) 
        // }el-table_7_column_30
        // 单元格样式
        tableCellStyle({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color:#b7e0ff;padding:0px;border-color: #000000;border-top:#000000; '
            }

            if (rowIndex === 3) {
                return 'padding:0px;border-color: #000000;border-top:#000000'
            }
            return 'border-color: #000000;padding:1px;border-left:#000000'
        },
        // 合并单元格
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                if (columnIndex === 0) {
                    return {
                        rowspan: 1,
                        colspan: 4
                    };
                    // return [1, 4];
                }
                else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
            if (rowIndex === 1) {
                if (columnIndex === 1) {
                    return {
                        rowspan: 1,
                        colspan: 4
                    };
                }
                else if (columnIndex != 1 && columnIndex != 0) {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
            if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4 || rowIndex === 5 || rowIndex === 6) {
                if (columnIndex === 1) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    };
                }
                else if (columnIndex != 0 && columnIndex != 2) {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }

            }
            if (columnIndex === 2) {
                if (rowIndex === 2) {
                    return {
                        rowspan: 5,
                        colspan: 1
                    };
                }
                else if (rowIndex != 7) {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }

        },
        setTableData() {

            var data = this.deviceinfo;
            console.log(data)
            for (var i = 0; i < data.length; i++) {


                // this.$nextTick(() =>
                this.updateTable(data[i])
                // )

                // this.deviceinfoData[1].prop2 = data[i].zcmc
                // this.deviceinfoData[2].prop2 = data[i].glbh
                // this.deviceinfoData[2].prop3 = data[i].qrcodeUrl
                // this.deviceinfoData[3].prop2 = data[i].sccj
                // this.deviceinfoData[4].prop2 = data[i].ccbh
                // this.deviceinfoData[5].prop2 = data[i].sbxh
                // this.deviceinfoData[6].prop2 = data[i].cgrq
                // this.deviceinfoData[7].prop2 = data[i].companyname
                // this.deviceinfoData[7].prop4 = data[i].bgr


            }



        },
        updateTable(data) {
            this.deviceinfoData = []
            this.deviceinfoData.push({
                prop1: "设备管理卡片"
            }, {
                prop1: "资产名称",
                prop2: ""
            }, {
                prop1: "设备编号",
                prop2: "",
                prop3: "",
            }, {
                prop1: "生产厂家",
                prop2: ""
            }, {
                prop1: "出厂编号",
                prop2: ""
            }, {
                prop1: "规格型号",
                prop2: ""
            }, {
                prop1: "购置日期",
                prop2: ""
            }, {
                prop1: "所属部门",
                prop2: "",
                prop3: "保管人",
                prop4: "",

            })
            this.deviceinfoData[1].prop2 = data.zcmc
            this.deviceinfoData[2].prop2 = data.glbh
            this.deviceinfoData[2].prop3 = data.qrcodeUrl
            this.deviceinfoData[3].prop2 = data.sccj
            this.deviceinfoData[4].prop2 = data.ccbh
            this.deviceinfoData[5].prop2 = data.sbxh
            this.deviceinfoData[6].prop2 = data.cgrq
            this.deviceinfoData[7].prop2 = data.companyname
            this.deviceinfoData[7].prop4 = data.bgr
            const setup = {
                useCORS: true, // 使用跨域
            };
            html2canvas(this.$refs.sor, setup).then((canvas) => {
                this.map.set(data.zcmc, canvas.toDataURL("image/jpg"));
                this.exportPicture(this.map.get(data.zcmc), data.zcmc);

            });
        }
    },
    created() {
        // this.setTableData();
    }
}

</script>

<style lang="less" scoped>
.el-table--border {
    border-color: #000000 !important;
    width: 320px;
    border-right: 1px solid #000000 !important;
    border-bottom: 1px solid #000000 !important;
}

#table /deep/ .cell {
    padding-left: 2px !important;
    padding-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/market/Deviceinfo_cardPL.vue